// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1N7ff","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__26haG"};